<template>
  <cube-popup
    v-show="isVisible"
    type="my-popup"
    :center="false"
    position="right"
    class="filter-wrap"
  >
    <div class="areas-searchs-box">
      <cube-input
        ref="searchInput"
        v-model="searchValue"
        :clearable="{visible: true, blurHidden: false}"
        @change="searchHandle"
        @input="handleInput"
      >
        <template slot="prepend">
          <i class="iconfont iconicon-test29" />
        </template>
        <template slot="append">
          <span
            class="text-btn search"
            @click="handleSearch"
          >{{ isEnglish ? 'Search' : '搜索' }}</span>
        </template>
      </cube-input>
    </div>
    <div class="main-content">
      <div class="item-content">
        <span
          v-for="(subitem,subindex) in selectedArray"
          :key="subindex"
          class="sub-text"
          @click="handleSubTitle(subitem, subindex)"
        >{{ subitem && subitem.name }}</span>

        <span
          v-if="selectedArray.length < 4 && !isLastChild"
          class="operate-text"
        >{{ isEnglish ? 'Please select' : '请选择' }}</span>
      </div>
      <div
        v-if="isNoSearch"
        class="item-content"
      >
        <span class="nosearch-text">{{ isEnglish ? 'No search result' : '暂无搜索结果' }}</span>
      </div>

      <div
        ref="chooseBscroll"
        class="choose-list"
      >
        <ul>
          <li
            v-for="(item,index) in renderDatas"
            :key="index"
            class="item-content"
            :class="{ disabled: item.disabled }"
            @click="handleSelected(item,index)"
          >
            <span
              class="text"
              :class="{textActive:item.selected}"
            >{{ item.name }}</span>
            <span
              v-if="item.selected"
              class="icon-span"
            >
              <i class="iconfont iconicon-test16" />
            </span>
            <span
              v-if="item.children"
              class="icon-span-right"
            >
              <span v-if="item.children.length">
                <i class="iconfont iconicon-test18" />
              </span>
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="operate-btn-div">
      <input
        type="button"
        class="cancel"
        :value="cancelTxt"
        @click="onCancel"
      >
      <input
        type="button"
        class="confirm"
        :class="{ confirmDis: disSaveBtn }"
        :value="okTTxt"
        @click="onSave"
      >
    </div>
  </cube-popup>
</template>
<script>
import BScroll from 'better-scroll'
import { getLang } from '@/lib/storage'
import { cloneDeep } from 'lodash'

export default {
  name: 'Members',
  props: {
    /**
     * 下拉列表的原始值
     */
    sourceDatas: {
      type: [Array, Object],
      default: () => ({})
    },
    /**
     * defaultValue: Array
     * [{id, keyname}, {id, keyname}]
     */
    defaultValue: {
      type: Array,
      default: () => ([])
    },
    visible: {
      type: Boolean,
      default: false
    },
    isMustLast: { // 必须选到末级
      type: Boolean,
      default: false
    },
    isFirstLast: { // 必须选择第一级或最后一级（信息来源选择）
      type: Boolean,
      default: false
    },
    separator: { // 分割线
      type: String,
      default: '/'
    },
    fieldtype: { // 字段类型，目前有人员，来源，接待方式
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isVisible: this.visible,
      show: true,
      searchValue: '',
      renderDatas: [], // 当前可选择的列表数据，根据选择结果变化
      selectedArray: [],
      isLastChild: false,
      isNoSearch: false,
      localSourceDatas: [], // 根据传入的下拉列表，处理的所以列表数据
      disSaveBtn: false // 保存按钮是否置灰
    }
  },

  computed: {
    cancelTxt () {
      return this.isEnglish ? 'Cancel' : '取消'
    },
    okTTxt () {
      return this.isEnglish ? 'Confirm' : '确定'
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
  },

  watch: {
    visible: {
      handler (val) {
        this.isVisible = val
      },
      immediate: true
    },
    isVisible: {
      handler (val) {
        if (val && this.defaultValue.length) {
          this.selectedResult(this.defaultValue)
        }
      },
      immediate: true
    },
    sourceDatas: {
      handler (val) {
        if (!val) return
        if (Array.isArray(val)) {
          const [first] = val
          if (first) {
            // 处理下拉列表的默认数据格式
            if (first.fieldname) {
              // 来源类型: first.fieldname
              this.localSourceDatas = this.switchFromDatas(val)
            } else if (this.fieldtype === 'select_reception') {
              // 接待方式
              this.localSourceDatas = this.switchReceptionDatas(val)
            } else {
              // 人员类型：first.name
              this.localSourceDatas = val
            }

            // 如果有默认选择值，处理下拉列表的选中状态和已选数据
            if (this.defaultValue && this.defaultValue.length) {
              this.selectedArray = this.defaultValue
              this.setDefaultData(this.localSourceDatas)
            } else {
              this.renderDatas = this.initSelectStatus(this.localSourceDatas)
            }
          }
        }
      },
      immediate: true
    },
    selectedArray: {
      handler (val) {
        this.setDisSaveBtn()
      },
      deep: true,
      immediate: true
    },
    isLastChild (val) {
      this.setDisSaveBtn()
    }
  },

  created () {
    this.$nextTick(() => {
      this.setScroll()
    })
  },

  methods: {
    getLang,
    setScroll () {
      if (!this.scroll || !this.$refs.chooseBscroll) {
        this.scroll = new BScroll(this.$refs.chooseBscroll, {
          click: true
        })
      } else {
        this.scroll.refresh()
      }
    },
    selectedResult (val) {
      if (!val) return
      if (Array.isArray(val)) {
        if (val.length) {
          if (this.sourceDatas && this.sourceDatas.length) {
            const [first] = this.sourceDatas
            if (first) {
              if (first.fieldname) {
                // 来源
                this.localSourceDatas = this.switchFromDatas(this.sourceDatas)
              } else if (this.fieldtype === 'select_reception') {
                // 接待方式
                this.localSourceDatas = this.switchReceptionDatas(this.sourceDatas)
              } else {
                // 人员
                this.localSourceDatas = this.sourceDatas
              }

              this.selectedArray = val
              this.setDefaultData(this.localSourceDatas)
              let len = this.selectedArray.length
              if (len) {
                this.isLastChild = !this.selectedArray[len - 1].children || !this.selectedArray[len - 1].children.length
              }
            }
          }
        }
      }
    },
    // 设置确定按钮不可点击
    setDisSaveBtn () {
      if (!this.selectedArray.length) {
        this.disSaveBtn = true
      } else if (this.isFirstLast && this.selectedArray.length === 2) {
        this.disSaveBtn = true
      } else if (this.isMustLast && this.selectedArray.length && !this.isLastChild) {
        this.disSaveBtn = true
      } else {
        this.disSaveBtn = false
      }
    },
    // 输入框图标状态改变方法
    handleIconStatusChange () {
      if (this.show) {
        this.show = false
      } else {
        this.show = true
      }
    },
    // 搜索keyup事件
    async searchHandle (e) {
      const keyword = e.target.value
      this.selectedArray = []
      this.isLastChild = false
      this.searchValue = keyword
      if (keyword) {
        this.getSearchMembers(keyword)
      } else {
        this.renderDatas = this.initSelectStatus(this.localSourceDatas)
      }
    },
    handleInput (value) {
      this.searchValue = value
      if (!value) {
        this.initDatas()
      }
    },
    // 来源
    switchFromDatas (data) {
      const tempv = []
      // console.log('switchFromDatas', data)
      data.map(value => {
        let json = {
          keyname: 'fieldkey',
          oldId: value.id,
          id: value.fieldkey,
          name: value.fieldname,
          fieldtype: value.fieldtype
        }
        if (value.child) {
          json.children = []
          for (const key in value.child) {
            let json2 = {
              keyname: 'fieldkey',
              oldId: value.child[key].id,
              id: value.child[key].fieldkey,
              name: value.child[key].fieldname,
              fieldtype: value.child[key].fieldtype
            }
            if (value.child[key].options) {
              json2.children = []
              value.child[key].options.map(values => {
                json2.children.push({
                  keyname: 'fieldkey',
                  oldId: value.id,
                  id: values.id,
                  name: values.name,
                  fieldtype: value.fieldtype
                })
              })
            }
            json.children.push(json2)
          }
        }
        tempv.push(json)
      })
      tempv.unshift({
        id: '-1',
        keyname: 'fieldkey',
        name: this.isEnglish ? 'All sources' : '全部来源'
      })
      return tempv
    },
    switchReceptionDatas (data) {
      return data.map(value => {
        let json = {
          keyname: 'fieldkey',
          oldId: value.id,
          id: value.id,
          name: value.name,
          fieldtype: value.fieldtype
        }
        if (value.children && value.children.length) {
          json.children = value.children.map(child => {
            return {
              keyname: 'fieldkey',
              oldId: child.id,
              id: child.id,
              name: child.name,
              fieldtype: child.fieldtype
            }
          })
        }
        return json
      })
    },
    handleKeyUp (val) {
      this.selectedArray = []
      this.isLastChild = false
      if (this.searchValue) {
        this.getSearchMembers(this.searchValue)
      } else {
        this.renderDatas = this.initSelectStatus(this.localSourceDatas)
      }
    },
    handleSearch () {
      this.selectedArray = []
      this.isLastChild = false
      if (this.searchValue) {
        this.getSearchMembers(this.searchValue)
      } else {
        this.renderDatas = this.initSelectStatus(this.localSourceDatas)
      }
    },
    // 设置默认值
    setDefaultData (array = []) { // array 是sourceData
      const { defaultValue = [] } = this
      const len = defaultValue.length
      let lastItem = defaultValue[len - 1]
      let lastTwoItem = defaultValue[len - 2]
      let renderList = []

      if (!Array.isArray(array)) return

      if (len === 0) {
        this.renderDatas = this.initSelectStatus(array)
      } else {
        let newArray = []
        let i = 0
        let copyArray = cloneDeep(array)
        while (i < len) {
          let one = this.defaultValue[i]
          let [nextItem = {}] = copyArray.filter(item => one.keyname === item.keyname && one.id === item.id)
          newArray.push(nextItem)
          if (nextItem && nextItem.children && nextItem.children.length) {
            copyArray = nextItem.children
          } else {
            copyArray = []
          }
          i++
        }
        if (lastItem && lastItem.children && lastItem.children.length) {
          renderList = lastItem.children
        } else if (lastTwoItem && lastTwoItem.children && lastTwoItem.children.length) {
          renderList = lastTwoItem.children
        } else {
          renderList = array
        }
        // console.log(renderList, newArray)

        this.selectedArray = newArray
        this.renderDatas = this.initSelectStatus(renderList, lastItem)
      }
    },
    // 获取人员数组
    getSearchMembers (searchText) {
      let membersArray = JSON.parse(JSON.stringify(this.localSourceDatas))

      this.getSearchFrom(membersArray, searchText)
    },
    // 获取来源和人员搜索
    getSearchFrom (arr, searchText) {
      const remainMembers = []
      // console.log('fromArr', arr)
      if (!arr || !arr.length) return

      loop(null, JSON.parse(JSON.stringify(arr)))
      function loop (parent, children) {
        children.forEach(item => {
          const parentItems = (parent || {}).item || []
          item.item = parentItems.concat(JSON.parse(JSON.stringify(item)))

          if (item.children && item.children.length) {
            loop(item, item.children)
          } else if (item.item.find(val => val.name.indexOf(searchText) > -1)) {
            item.name = item.item.map(val => val.name).join(' > ')
            remainMembers.push(item)
          }
        })
      }
      if (remainMembers.length > 0) {
        this.isNoSearch = false
      } else {
        this.isNoSearch = true
      }
      this.renderDatas = remainMembers
    },

    // subtitle 点击事件
    handleSubTitle (item, index) {
      this.searchValue = '' // 情况搜索输入框内容

      if (index === 0) {
        this.renderDatas = this.initSelectStatus(this.localSourceDatas)
        this.selectedArray = []
        this.isLastChild = false
        return
      }
      if (item.children) {
        this.renderDatas = this.initSelectStatus(item.children)
        this.selectedArray = this.selectedArray.slice(0, index + 1)
      }
    },
    // 选中操作处理方法
    handleSelected (item, index) {
      if (item.disabled) return

      this.addActiveItem(item)

      if (this.searchValue) {
        if (item.item) {
          this.selectedArray = item.item
        } else {
          this.selectedArray = [item]
        }
        return
      }

      if (item.children) {
        if (item.children.length) {
          this.isLastChild = false
          this.renderDatas = this.initSelectStatus(item.children)
        } else {
          this.isLastChild = true
        }
      } else {
        this.isLastChild = true
      }

      let length = this.selectedArray.length
      if (length === 0) {
        this.selectedArray.push(item)
        return
      }

      if (this.selectedArray[length - 1].children) {
        if (this.selectedArray[length - 1].children.length) {
          this.selectedArray.push(item)
        } else {
          this.selectedArray[length - 1] = item
        }
      } else {
        this.selectedArray[length - 1] = item
      }
    },
    // 添加选中判断字段
    addActiveItem (item) {
      let tempv = JSON.parse(JSON.stringify(this.renderDatas))

      tempv.forEach(value => {
        if (this.searchValue) {
          if (value.id === item.id && value.item.length === item.item.length) {
            value.selected = true
          } else {
            value.selected = false
          }
          this.isLastChild = true
        } else {
          if ((`${value.keyname}-${value.id}`) === (`${item.keyname}-${item.id}`)) {
            value.selected = true
          } else {
            value.selected = false
          }
        }
      })
      this.renderDatas = tempv
    },
    onShow () {
      this.isVisible = true
    },
    // 取消操作
    onCancel () {
      this.isVisible = false
      this.$emit('update', false)
      this.$emit('update:visible', false)
      this.initDatas()
    },

    // 保存回调操作
    onSave () {
      if (!this.selectedArray.length) return
      if (this.isMustLast) {
        if (!this.isLastChild) {
          return
        }
      }
      if (this.isFirstLast) {
        if (this.selectedArray.length === 2) {
          return
        }
      }
      const params = {
        text: '',
        value: []
      }
      this.selectedArray.map(vvs => {
        if (vvs.name) {
          params.text += (this.separator + vvs.name)
          delete vvs.selected
          params.value.push(vvs)
        }
      })
      params.text = params.text.substr(1)

      this.isVisible = false
      this.$emit('update', false)
      this.$emit('update:visible', false)
      this.$emit('change', params)
      this.initDatas()
    },
    initDatas () {
      this.isNoSearch = false
      this.isLastChild = false
      this.selectedArray = []
      this.searchValue = ''
      this.renderDatas = this.initSelectStatus(this.localSourceDatas)
    },
    // 初始化选中状态
    initSelectStatus (array = [], item) {
      array.map(value => {
        if (item) {
          if (item.keyname === value.keyname && item.id === value.id) {
            value.selected = true
          } else {
            value.selected = false
          }
        } else {
          value.selected = false
        }
      })
      return array
    }
  }
}
</script>
<style lang="scss">
.areas-searchs-box {
  .cube-input-clear {
    margin-left: -38px !important;
  }
  .search {
    margin-left: 4px;
    margin-right: 2px;
  }
}
</style>

<style lang="scss" scoped>
.filter-wrap::v-deep {
  height: 100%;
  .areas-searchs-box {
    box-sizing: content-box;
    background: #f5f5f5;
    .cube-input_active:after {
      border: none !important;
    }
    .cube-input {
      padding: 8px;
      background-color: #f1f1f1;
      .cube-input-prepend {
        position: absolute;
        left: 13px;
        color: #999;
      }
      .cube-input-field {
        margin-right: 8px;
        padding: 7px 10px 7px 30px;
        background-color: #fff;
        border-radius: 4px;
      }
      .cube-input-append {
        color: $primary-color;
      }
    }
  }
  .search-input-content {
    width: 375px;
    height: 44px;
    background: rgba(245, 245, 245, 1);
    .search-input {
      width: 357px;
      height: 28px;
      margin-left: 9px;
      margin-top: 8px;
      outline: none;
      background-color: rgba(255, 255, 255, 1);
    }
    .search_place {
      position: relative;
      height: 28px;
      line-height: 28px;
      text-align: center;
      top: 8px;
      width: 80px;
      margin-bottom: -28px;
      margin-left: 150px;
      .searchicon {
        font-size: 18px;
        color: #d6d6d6;
      }
      span {
        color: #bbb;
        margin: 0 10px;
        height: 28px;
        line-height: 28px;
        font-size: 16px;
        font-weight: 400;
        display: inline-block;
        color: rgba(187, 187, 187, 1);
      }
    }
  }

  .main-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100% - 62px - 52px);
    .choose-list {
      flex: 1;
      overflow: scroll;
      .item-content:last-child {
        border-bottom: none;
      }
    }
    .item-content {
      width: 375px;
      height: 48px;
      background: rgba(255, 255, 255, 1);
      border-bottom: solid 1px rgba(219, 219, 219, 1);
      &.disabled .text {
        color: #b3b3b3;
      }
      .sub-text {
        max-width: 105px;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        font-weight: 400;
        color: rgba(80, 119, 170, 1);
        margin-left: 12px;
      }
      .nosearch-text {
        width: 100%;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        display: inline-block;
        font-weight: 400;
        text-align: center;
        color: rgba(153, 153, 153, 1);
      }
      .operate-text {
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        overflow: hidden;
        display: inline-block;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        margin-left: 12px;
      }
      .text {
        width: 310px;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-left: 12px;
      }
      .textActive {
        width: 310px;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        display: inline-block;
        font-weight: 400;
        color: rgba(81, 120, 170, 1);
        margin-left: 12px;
      }
      .icon-span {
        line-height: 48px;
        display: inline-block;
        color: rgba(80, 119, 170, 1);
        vertical-align: top;
        text-align: right;
        width: 30px;
      }
      .icon-span-right {
        line-height: 48px;
        width: 30px;
        display: inline-block;
        color: #ccc;
        text-align: right;
        vertical-align: top;
      }
    }
  }
  .operate-btn-div {
    display: flex;
    // height: 62px;
    width: 375px;
    padding: 8px 0;
    background-color: #fff;
    position: absolute;
    bottom: 0px;
    border-top: solid 1px rgba(219, 219, 219, 1);
    > span {
      display: flex;
    }
    .confirm {
      width: 176px;
      margin-left: 8px;
      height: 46px;
      line-height: 46px;
      // margin-top: 8px;
      background: linear-gradient(
        360deg,
        rgba(80, 119, 170, 1) 0%,
        rgba(96, 143, 204, 1) 100%
      );
      outline: none;
      color: rgba(255, 255, 255, 1);
      box-shadow: 0px 1px 1px 0px rgba(255, 255, 255, 0.5);
      border-radius: 4px;
      border: 1px solid rgba(80, 119, 170, 1);
    }
    .confirmDis {
      width: 176px;
      margin-left: 8px;
      height: 46px;
      line-height: 46px;
      // margin-top: 8px;
      background: linear-gradient(
        360deg,
        rgba(80, 119, 170, 0.5) 0%,
        rgba(96, 143, 204, 0.5) 100%
      );
      outline: none;
      color: rgba(255, 255, 255, 1);
      box-shadow: 0px 1px 1px 0px rgba(255, 255, 255, 0.5);
      border-radius: 4px;
      border: 1px solid rgba(80, 119, 170, 0.5);
    }
    .cancel {
      width: 176px;
      height: 46px;
      line-height: 46px;
      margin-left: 8px;
      // margin-top: 8px;
      outline: none;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(219, 219, 219, 1);
    }
  }
}
</style>
